
import * as handlebars_family from "../handlebars_family.ts";

const TPL = handlebars_family.addTemplate("modal/media_in_modal",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, helper, options, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    }, buffer = 
  " <flexcol style=\"gap:var(--space)\"><div style=\"opacity:0.5;padding-left:13px\">"
    + container.escapeExpression(lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"labels.attachment",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":92},"end":{"line":1,"column":120}}}))
    + "</div> "
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"medias") : depth0),{"name":"each","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":127},"end":{"line":1,"column":452}}})) != null ? stack1 : "")
    + " ";
  stack1 = ((helper = (helper = lookupProperty(helpers,"lastMediaImage") || (depth0 != null ? lookupProperty(depth0,"lastMediaImage") : depth0)) != null ? helper : container.hooks.helperMissing),(options={"name":"lastMediaImage","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":453},"end":{"line":1,"column":721}}}),(typeof helper === "function" ? helper.call(depth0 != null ? depth0 : (container.nullContext || {}),options) : helper));
  if (!lookupProperty(helpers,"lastMediaImage")) { stack1 = container.hooks.blockHelperMissing.call(depth0,stack1,options)}
  if (stack1 != null) { buffer += stack1; }
  return buffer + " </flexcol> ";
},"2":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <flexrow data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" data-fw-onclick=\"fileview\" data-media-viewer-group=\"modal-gallery\"><flexcenter style=\"width:50px\" class=\"spaced\"> "
    + ((stack1 = (lookupProperty(helpers,"iconsimple")||(depth0 && lookupProperty(depth0,"iconsimple"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"font-size:24px;",{"name":"iconsimple","hash":{},"data":data,"loc":{"start":{"line":1,"column":298},"end":{"line":1,"column":332}}})) != null ? stack1 : "")
    + " </flexcenter><flexauto><p class=\"line\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"name") : depth0), depth0))
    + "</p><p class=\"line sub2\">"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"size") : depth0), depth0))
    + "</p></flexauto></flexrow> ";
},"4":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"cover flexcenter\" style=\"background-image:url('"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"pictureUrl") : depth0), depth0))
    + "w=1024&h=512&s=r');background-color:"
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"color") : depth0), depth0))
    + "\" data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\" data-media-viewer-group=\"modal-gallery\" data-fw-onclick=\"fileview\"></div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"medias") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":1,"column":740}}})) != null ? stack1 : "")
    + " ";
},"useData":true});
export default TPL;